module.exports = __webpack_public_path__ + "static/gallery3-0f5c1328ca1233a4b286a794394468a8.png";